var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.$root.manutencao)?_c('Manutencao'):(_vm.$root.fila > 0)?_c('Fila'):_c('router-view'),_c('Modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }